let preloadSupported = -1
let modulePreloadSupported = false
const checkPreloadSupported = () => {
  if (preloadSupported === -1) {
    const link = document.createElement('link')
    const relList = link.relList
    if (!relList || !relList.supports) {
      preloadSupported = false
    } else {
      preloadSupported = relList.supports('preload')
      modulePreloadSupported = relList.supports('modulepreload')
    }
  }
}

/**
 * 通过 preload 预加载 html 入口
 * @param {*} url
 * @returns
 */
function preloadHtml(url) {
  return new Promise((resolve, reject) => {
    const iframe = document.createElement('iframe')
    iframe.sandbox = ''
    iframe.src = url
    iframe.width = 1
    iframe.height = 1
    iframe.onload = () => {
      document.body.removeChild(iframe)
      resolve()
    }
    iframe.onerror = reject
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
  })
}

/**
 * 通过 preload 预加载资源
 */
function preloadSource(url, isModule = false) {
  return new Promise((resolve, reject) => {
    let type = 'style'
    if (url.includes('.js')) {
      type = 'script'
    } else if (url.includes('.ttf') || url.includes('.woff')) {
      type = 'font'
    }
    const link = document.createElement('link')
    link.rel = modulePreloadSupported && isModule && type === 'script' ? 'modulepreload' : 'preload'
    if (type) {
      if (type === 'font' || type === 'script') {
        link.crossOrigin = 'anonymous'
      }
      link.as = type
      link.href = url
      link.onload = resolve
      link.onerror = reject
      document.head.appendChild(link)
    } else {
      resolve()
    }
  })
}

function xhrPrefetchStrategy(url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.withCredentials = false
    xhr.open(`GET`, url)
    xhr.onload = () => {
      xhr.status === 200
        ? resolve({
            status: xhr.status,
            text: async () => {
              return xhr.responseText
            }
          })
        : reject(new Error(`http status ${xhr.status}`))
    }
    xhr.onerror = reject
    xhr.send()
  })
}

/**
 * 预加载
 * @param {*} url 资源链接
 * @param {*} canPreload 是否需要响应结果
 * @param {*} isModule 是否是模块
 * @returns
 */
export async function prefetch(url, needResponse = false, isModule = false) {
  checkPreloadSupported()
  let res = null
  if (preloadSupported) {
    if (url.includes('.html') || !url.includes('.')) {
      res = await preloadHtml(url)
    } else {
      res = await preloadSource(url, isModule)
    }
  }
  if (needResponse) {
    if (window.fetch) {
      return window.fetch(url, {})
    } else {
      return xhrPrefetchStrategy(url)
    }
  }
  return res
}

// 需要预加载的 rel
const prefetchRels = ['prefetch', 'modulepreload', 'stylesheet']

/**
 * 去除引号
 * @param {*} str
 */
function trimQuote(str) {
  if (str.startsWith('"') || str.startsWith("'")) {
    str = str.slice(1)
  }
  if (str.endsWith('"') || str.endsWith("'")) {
    str = str.slice(0, -1)
  }
  return str
}

/**
 * 处理基础路径，目前都是简单的相对路径，暂时不去考虑复杂的相对路径引用
 * @param {*} path
 * @param {*} baseUrl
 * @returns
 */
function resolveBaseUrl(path, baseUrl) {
  if (path.startsWith('http') || path.startsWith('//')) {
    return path
  }
  if (!baseUrl.endsWith('/')) {
    baseUrl += '/'
  }
  if (path.startsWith('./')) {
    return baseUrl + path.replace('./', '')
  }
  return path
}

/**
 * 从 html 中扫描静态资源
 * @param {String} content
 * @param {String} baseUrl
 */
export function scanStaticFiles(content, baseUrl) {
  return new Promise((reslove) => {
    const scripts = []
    let isModule = false
    const styles = []
    const others = []
    const arr = content.split('<link ')
    for (let i = 1, len = arr.length; i < len; i++) {
      const item = arr[i].split('>')[0]
      let prefetch = false
      for (const rel of prefetchRels) {
        if (item.includes(rel)) {
          prefetch = true
          break
        }
      }
      if (prefetch) {
        const arr1 = item.split(' ').filter((r) => r.includes('href='))
        if (arr1.length) {
          let href = arr1[0].replace('href=', '')
          href = trimQuote(href)
          href = resolveBaseUrl(href, baseUrl)
          if (item.includes('.css')) {
            if (!styles.includes(href)) {
              styles.push(href)
            }
          } else if (item.includes('.js')) {
            if (!scripts.includes(href)) {
              scripts.push(href)
            }
          } else {
            if (!others.includes(href)) {
              others.push(href)
            }
          }
        }
      }
    }
    const arr2 = content.split('<script ')
    for (let i = 1, len = arr2.length; i < len; i++) {
      const regResult = arr2[i].match(/src=('|")?([^ >]+)('|")?/gi)
      if (regResult && regResult.length) {
        if (arr2[i].includes('module')) {
          isModule = true
        }
        let item = regResult[0].replace('src=', '')
        item = trimQuote(item)
        item = resolveBaseUrl(item, baseUrl)
        if (item.indexOf('.js') > 0 && scripts.indexOf(item) == -1) {
          scripts.push(item)
        }
      }
    }
    reslove({
      scripts,
      styles,
      others,
      isModule
    })
  })
}
